import { GetEventQuery } from "graphql/event.types";
import { EventModel } from "models/Event";
import { createContext, useContext } from "react";

export type EventContextType = {
    event?: GetEventQuery["event"];
    eventObject?: EventModel | null;
    eventChannel?: string;
}

export const EVENT_CHANNEL_HOOK_ERROR = "Error: `useEventChannel` must be used within an `EventProvider`";

const EventContext = createContext<EventContextType>({});
EventContext.displayName = "Event";

export const useEvent = () => useContext(EventContext).event;

export const useEventObject = () => useContext(EventContext).eventObject;

export const useEventChannel = () => {
    const eventChannel = useContext(EventContext).eventChannel;
    if (!eventChannel) {
        throw new Error(EVENT_CHANNEL_HOOK_ERROR);
    }
    return eventChannel;
};

export const EventProvider = EventContext.Provider;